import React from "react"
import { Tooltip } from "@shopify/polaris"
import { useTranslation } from "react-i18next"

export const DiscordButton = () => {
	const { t } = useTranslation()

	return (
		<Tooltip
			content={
				<div style={{ padding: "0.2rem 0.4rem" }}>
					<span style={{ fontSize: "0.8rem", color: "#222" }}>
						{t("header.discord_tooltip")}
					</span>
				</div>
			}
		>
			<a
				id="discord-button-text"
				href="https://discord.gg/X7NW5aEpJx"
				target="_blank"
				rel="noopener noreferrer"
				style={{
					background: "#dfe2fe",
					borderRadius: "5rem",
					padding: "0.4rem",
					position: "relative",
					display: "block",
				}}
			>
				<div
					style={{
						cursor: "pointer",
						verticalAlign: "middle",
						height: "1.25rem",
						display: "flex",
						gap: "0.3rem",
						alignItems: "center",
					}}
				>
					<div
						style={{
							cursor: "pointer",
							verticalAlign: "middle",
							width: "1.25rem",
							height: "1.25rem",
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1.25rem"
							height="1.25rem"
							viewBox="0 0 256 199"
						>
							<path
								fill="#5865F2"
								d="M216.856 16.597A208.502 208.502 0 0 0 164.042 0c-2.275 4.113-4.933 9.645-6.766 14.046c-19.692-2.961-39.203-2.961-58.533 0c-1.832-4.4-4.55-9.933-6.846-14.046a207.809 207.809 0 0 0-52.855 16.638C5.618 67.147-3.443 116.4 1.087 164.956c22.169 16.555 43.653 26.612 64.775 33.193A161.094 161.094 0 0 0 79.735 175.3a136.413 136.413 0 0 1-21.846-10.632a108.636 108.636 0 0 0 5.356-4.237c42.122 19.702 87.89 19.702 129.51 0a131.66 131.66 0 0 0 5.355 4.237a136.07 136.07 0 0 1-21.886 10.653c4.006 8.02 8.638 15.67 13.873 22.848c21.142-6.58 42.646-16.637 64.815-33.213c5.316-56.288-9.08-105.09-38.056-148.36ZM85.474 135.095c-12.645 0-23.015-11.805-23.015-26.18s10.149-26.2 23.015-26.2c12.867 0 23.236 11.804 23.015 26.2c.02 14.375-10.148 26.18-23.015 26.18Zm85.051 0c-12.645 0-23.014-11.805-23.014-26.18s10.148-26.2 23.014-26.2c12.867 0 23.236 11.804 23.015 26.2c0 14.375-10.148 26.18-23.015 26.18Z"
							></path>
						</svg>
					</div>

					<style>{`
						.discord-shine {
							background: linear-gradient(
								to right,
								#5765F2 0%,
								#5765F2 30%,
								#6b76f6 40%,
								#dfe2fe 50%,
								#6b76f6 60%,
								#5765F2 80%,
								#5765F2 100%
							);
							-webkit-background-clip: text;
							background-clip: text;
							-webkit-text-fill-color: transparent;
							text-fill-color: transparent;
							background-size: 500% auto;
							animation: textShine 1.5s ease-in-out infinite reverse;
						}

						@keyframes textShine {
							0% {
								background-position: 0% 50%;
							}
							100% {
								background-position: 100% 50%;
							}
						}
					`}</style>
				</div>
			</a>
		</Tooltip>
	)
}
